import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import {StoreSelectorsService} from "../../services";
import { Compbaser } from '../compbaser/compbases';

@Component({
    selector: 'app-category-filter',
    templateUrl: './category-filter.component.html',
    styleUrls: ['./category-filter.component.scss']
})
export class CategoryFilterComponent extends Compbaser implements OnInit {
    frmCategory = new FormControl();
    filteredCategories: Observable<string[]>;
    private modelChanged: Subject<string> = new Subject<string>();

    @Input() categories = [];
    @Input() hideLabel = false;
    @Input()
    set selectedCategory(category: string) {
        if (!category) this.frmCategory.setValue('');
        else this.frmCategory.setValue(category);
    }

    @Output() updateCategory: EventEmitter<any> = new EventEmitter<any>();

    constructor(public storeSelector: StoreSelectorsService) {
        super();
    }

    ngOnInit() {
        this.filteredCategories = this.frmCategory.valueChanges.pipe(
            startWith(''),
            // debounceTime(100),
            // distinctUntilChanged(),
            map(value => this._filter(value))
        );
        this.cod(
            this.modelChanged.pipe(
                debounceTime(500)
            )
            .subscribe(() => {
                this.onChangeCategory();
            }
        ));
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.categories.filter(category => category.toLowerCase().includes(filterValue));
    }

    // change catagory
    onKeyupCategory() {
        this.modelChanged.next(null);
    }

    // emit update event from input change action
    onChangeCategory() {
        this.updateCategory.emit(this.frmCategory.value);
    }

    // emit update event from select action
    onSelectionChange(event) {
        this.updateCategory.emit(event.option.value);
    }

    clearSelection() {
        this.frmCategory.setValue('');
        this.updateCategory.emit('');
    }
}
